<script setup>
import { Icon } from '@components'

import Toast from '@utils/Toast'

</script>

<template>
    <div class="flex flex-col gap-4 z-[9999999]">
        <transition-group appear name="slide-fade">
            <div v-for="(item, index) in Toast.items" :key="index" class="flex items-center gap-5 p-4 border shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] rounded-xl border-solid border-[#EAECF0] w-[400px] bg-white">
                <div class="p-2.5 rounded-full w-10 h-10" :style="`background: ${item.iconBgColor}`">
                    <Icon size="20px" :name="item.icon" :style="`color: ${item.iconColor}`" />
                </div>
                <div class="text-[#101828] text-sm font-semibold">{{ item.message }}</div>
                <Icon @click="Toast.close(item.id)" size="20px" name="xClose" class="text-[#475467] ml-auto cursor-pointer" />
            </div>
        </transition-group>
    </div>
</template>
